import {Link, useHistory} from "react-router-dom";
import StandardTable, {StandardColumnsType} from "../../components/StandardTable";
import {Button, Space} from "antd";
import PageHeaderLayout from "../../layout/pageHeaderLayout";
import useAntTable from "../../utils/useAntTable";
import * as api from "../../apis/presaleOrder";
import dayjs from "dayjs";
import {LogType, PresaleOrderStatusMapping, PresaleOrderStatusOptions} from "../../utils/constants";
import LogModal from "../../components/LogModal";
import OrderContactModal from "../../components/OrderContactModal";
import {useState} from "react";
import {useRequest} from "ahooks";
import withAuth from "../../utils/withAuth";
import useQueryParam from "../../utils/useQueryParam";

const ContactButton = withAuth('contact', Button);
const ExportOrderButton = withAuth('exportOrder', Button);

enum OrderPageType {
    presale = 'presale', stockout = "stockout"
}

enum OrderType {
    presale = "preOrder",
    outstock = 'outStockOrder'
}

const OrderTypeMap = {
    preOrder: '预订订单',
    outStockOrder: '缺货订单'
}

function PresaleOrder(props: any) {
    const history = useHistory();
    const pageType = history.location.pathname.indexOf('presale') >= 0 ? OrderPageType.presale : OrderPageType.stockout;
    const orderType = pageType === OrderPageType.presale ? OrderType.presale : OrderType.outstock;
    const [contactOrder, setContactOrder] = useState<number | string>();

    const {loading: loadingContact, run: runContact} = useRequest(api.contactOrder, {
        manual: true,
        onSuccess(res) {
            setContactOrder(undefined);
            refresh();
        }
    })


    const columns: StandardColumnsType = [
        {
            dataIndex: 'code',
            title: orderType == OrderType.presale ? '预订单号' : '缺货单号'
        },
        {
            dataIndex: 'dealerName',
            title: '客户名称'
        },
        {
            dataIndex: 'groupName',
            title: '集团'
        },
        {
            dataIndex: 'categoryName',
            title: '产品线'
        },
        {
            dataIndex: 'hospitalFullName',
            title: '终端医院'
        },
        {
            dataIndex: 'orderDate',
            title: '订单日期',
            render(v) {
                return dayjs(v).format('ll')
            }
        },
        {
            dataIndex: 'status',
            title: '状态',
            render(v) {
                return PresaleOrderStatusMapping[v];
            }
        },
        {
            dataIndex: 'productTotalAmount',
            title: '订单合计'
        },
        {
            dataIndex: 'contacted',
            title: '已联系',
            render(v, record: any) {
                return v ? '是' : '否'
            }
        },
        {
            title: '操作',
            width: 140,
            fixed: 'right',
            dataIndex: 'operation',
            render(_, record: any) {
                return <Space>
                    <Link to={`/order/${pageType}/detail/${record.id}`}>详情</Link>
                    <Button type={"link"} onClick={() => LogModal.open(LogType.PresaleOrder, record.id)}>日志</Button>
                    <ContactButton type={"link"} onClick={() => handleContact(record)}>联系</ContactButton>
                </Space>
            }
        }
    ];


    const {
        tableProps,
        refresh,
        form,
        search,
        downloading,
        download
    } = useAntTable(api.getPresaleOrders, {
        method: 'post',
        defaultParams: {orderType},
        downloadUrl: api.exportOrderUrl
    });
    const searchColumns: StandardColumnsType = [
        {
            dataIndex: 'code',
            title: pageType === OrderPageType.presale ? '预订单号' : '缺货单号',
            search: true
        },
        {
            dataIndex: 'dealerName',
            title: '客户名称',
            search: true
        },
        {
            dataIndex: 'status',
            title: '状态',
            search: {
                valueType: 'select',
                valueEnum: PresaleOrderStatusOptions
            }
        },
        {
            dataIndex: 'group',
            title: '集团',
            search: true
        },
        {
            dataIndex: 'contractCode',
            title: '合同编号',
            search: true
        },
        {
            dataIndex: 'productCode',
            title: '商品编号',
            search: true
        },
        {
            dataIndex: 'hospitalName',
            title: '终端医院全称',
            search: true
        },
        {
            dataIndex: 'orderDateRange',
            title: '订单日期',
            search: {
                valueType: 'dateRange'
            }
        },
        {
            dataIndex: 'businessMan',
            title: '商务人员',
            search: true
        },
    ];

    const handleContact = (record: any) => {
        setContactOrder(record.id);
    }

    const finishContact = (values: any) => {
        runContact(values);
    }

    const toolbar = (
        <Space>
            <ExportOrderButton type={"primary"} loading={downloading}
                               onClick={download}>订单列表导出</ExportOrderButton>
        </Space>
    )

    return <PageHeaderLayout>
        <StandardTable columns={columns} extSearchColumns={searchColumns} {...tableProps} form={form} search={search}
                       scroll={{x: '100%'}} toolbar={toolbar}/>
        <OrderContactModal contactOrderId={contactOrder} onCancel={() => setContactOrder(undefined)}
                           onComplete={finishContact} destroyOnClose/>
    </PageHeaderLayout>
};

export default PresaleOrder;
